module.exports = __webpack_public_path__ + "static/img/图层 570.43941383.png";